module.exports = __webpack_public_path__ + "static/media/negativeImpactTitle.817fb5d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/negativeImpactTitle.png
// module id = 1296
// module chunks = 0